import styled from 'styled-components'

const ActionBar = styled.div`
  position: absolute;
  top: 15px;
  right: 16px;
  margin-bottom: 8px;
  z-index: 1000;
`
export default ActionBar